import React from 'react';
import { useFormikContext } from 'formik';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';

import FieldArrayIterables from '~/commons/components/FieldArrayIterables.jsx';

const FieldArrayCards = ({
  name,
  push,
  pushTitle,
  children,
  disabled,
  disabledForItem = () => false,
}) => {
  const { status } = useFormikContext();
  const disable = disabled || status?.disabled;

  return (
    <FieldArrayIterables name={name} push={push} pushTitle={pushTitle}>
        {(r, i, helpers) => (
          <div className="card mb-3" key={i}>
          {!disable && !disabledForItem(r, i, helpers) && (
              <button
                className="btn btn-link close"
                type="button"
                style={{ zIndex: 1 }}
                onClick={() => helpers.remove(i)}>
                <FA icon={faTimes} size="sm" />
              </button>
            )}
            <div className="card-body">
              {children(r, i, helpers)}
            </div>
          </div>
        )}
      </FieldArrayIterables>
  );
};

export default FieldArrayCards;
